// Kabuk turu — ilk girişte bir kez, kabuğun kendi mobilyasına çapalı.
//
// Bu beş adım menu-config'ten TÜRETİLEMEZ, çünkü menü öğesi değiller. Ama
// türetmenin kazandırdığı şey ölmüyor: 1. adımın cümlesi buildTourSteps'ten
// gelen SAYIYI kullanıyor ("yetkiniz 37 sayfa açıyor"). Yerine geçtiği panel
// aynı sayıyı 37 SLAYT olarak anlatıyordu — ürünü ilk gören kişiye, ürünü
// göstermeden.
//
// Çözülemeyen çapa ATLANIR ve sayaç toplamına da girmez. AI düğmesi bir dağıtım
// bayrağının arkasında (TopBar: isSupportAssistantEnabled); bayrak kapalıyken o
// adım "5 adımdan 2." deyip boş çıkmak yerine hiç var olmaz.

import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Spotlight } from "./spotlight";
import { useTour } from "./tour-provider";
import { useResolvableAnchors } from "./use-resolvable-anchors";

// AYIRICI TİRE, İKİ NOKTA DEĞİL. `shell:rail` daha okunaklı görünüyor ve
// ÇALIŞMIYOR: i18next'in nsSeparator'ı ":" — t("tour.shell.shell:rail.title")
// "tour.shell.shell" ad uzayında "rail.title" anahtarını arar ve ekrana
// "rail.title" basar. Ölçüldü; geri çevirmeyin.
export const SHELL_TOUR_ANCHORS = [
  "shell-rail",
  "shell-ai",
  "shell-notifications",
  "shell-help",
  "shell-screen-tour",
] as const;

export function ShellTour(): React.ReactElement | null {
  const { t } = useTranslation();
  const tour = useTour();
  const panelOpen = tour?.panelOpen ?? false;

  // Tur açıkken SÜREKLİ çöz, bir kez değil: kabuk parçaları provider'dan sonra
  // mount oluyor ve "shell-screen-tour" çapası sayfa üstü kutuda yaşıyor — o
  // kutu artık kendi çapalarını asenkron çözdüğü için tetikleyici ilk
  // boyamadan sonra beliriyor. Bir kez ölçen build beş adımlık turu sessizce
  // dörde indiriyordu.
  const anchors = useResolvableAnchors(SHELL_TOUR_ANCHORS, "document", panelOpen);

  const stepIndex = tour === null ? 0 : Math.min(tour.stepIndex, Math.max(0, anchors.length - 1));

  const advance = useCallback(() => {
    if (tour === null) return;
    if (stepIndex >= anchors.length - 1) tour.acknowledge();
    else tour.setStepIndex(stepIndex + 1);
  }, [tour, stepIndex, anchors.length]);

  const back = useCallback(() => {
    tour?.setStepIndex(stepIndex - 1);
  }, [tour, stepIndex]);

  if (tour === null || !panelOpen || anchors.length === 0) return null;
  const anchorId = anchors[stepIndex];
  if (anchorId === undefined) return null;

  return (
    <Spotlight
      anchorId={anchorId}
      scope="document"
      stepIndex={stepIndex}
      stepCount={anchors.length}
      title={t(`tour.shell.${anchorId}.title`)}
      // count yalnız shell-rail'in cümlesinde geçiyor; diğerlerine zararsızca
      // geçmek, her adım için ayrı bir çağrı yazmaktan basit.
      body={t(`tour.shell.${anchorId}.body`, { count: tour.steps.length })}
      onNext={advance}
      onBack={back}
      // "Atla" ONAYLIYOR: 37 adımda "şimdi değil" ile "hiç" gerçekten farklı
      // cevaplardı ve panel iki ayrı çıkış taşıyordu; beş adımda değiller.
      onSkip={tour.acknowledge}
      // Escape ONAYLAMIYOR. Kasıtlı bir tıklama ile kazara bir tuş aynı niyet
      // değildir, ve her kapanışta yazan bir build turu tek tuşla sonsuza dek
      // susturur.
      onEscape={tour.closePanel}
    />
  );
}
